import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { importRoom } from "../../../services/section";
import BaseModal from "components/BaseModal";
import {
  Container,
  Row,
  Col,
  Alert,
} from "react-bootstrap";
import { resetBlockFlags, resetBlock } from "features/section/sectionSlice";

const ImportRoomModal = ({
  sectionDetails,
  onCloseModal,
  open,
}) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null)
  const {
      importRoom: {
        success,
        loading,
        error,
        data
      }
  } = useSelector(({ section }) => section);

  const submitHandler = async (e) => {
    e.preventDefault();
    let payload = new FormData();
    payload.append("file", file)
    const sectionId = sectionDetails.id;
    await dispatch(importRoom({ sectionId, payload }));
  };

  useEffect(() => {
    if (success === true) {
      toast.success("Room file has imported successfully.");
      if (data.errorCount === 0) {
        handleCloseModal();
      }
    }
  }, [success, error, data]);

  const handleCloseModal = () => {
    onCloseModal();
    setFile(null);
    dispatch(resetBlockFlags({ blockType: "importRoom" }))
    dispatch(resetBlock({ blockType: "importRoom" }))
  }
  return (
    <BaseModal
      onSubmit={submitHandler}
      onClose={handleCloseModal}
      show={open}
      title={"Import Room"}
      submitButtonText={"Import"}
      formWrapper={true}
      formLoading={loading}
      size={"lg"}
      content={
        <>
          <Container fluid>
              {data.errorCount &&
                <Alert
                    variant="warning"
                >
                    <p><b>Warning</b></p>
                    <p>{data.createdCount} rooms has been created and {data.updatedCount} rooms has been updated. </p>
                    <p>{data.errorCount} rooms was not imported.</p>
                    <ul>{data.errorMessages.map(message => (<li style={{ whiteSpace: 'pre-line' }}>{message}</li>))}</ul>
                </Alert>
              }
              <Row>
                <Col md={12}>
                  <div className="form-floating mb-4 go-bottom">
                    <input
                      required
                      type="file"
                      className="form-control"
                      name="file"
                      accept=".xls,.xlsx"
                      placeholder="Excel"
                       onChange={(e) => { 
                            if (e.target.files?.length)
                              setFile(e.target.files[0])
                            }
                        } 
                    />
                    <label htmlFor="name">Excel</label>
                  </div>
                </Col>
              </Row>
          </Container>

        </>
      }
    />
  );
};
export default ImportRoomModal;
